import { memo } from 'react';
import { Avatar } from '@aimsos/ui';

import { getAvatarColorClass } from '../../utils/avatarColor';
import { getInitials, isPlaceholderProfile } from '../../utils/memberDisplay';

/**
 * Avatar of a member: coloured initials, or the placeholder for someone with no profile yet.
 *
 * @param {object} props
 * @param {{ displayName?: string, name?: string, email?: string }} props.member UI member (`displayName`) or picker member (`name`).
 * @param {'md'|'lg'} [props.size='lg'] `md` shrinks the initials so they fit the circle.
 */
function MemberAvatar({ member, size = 'lg' }) {
  const name = member.displayName ?? member.name;
  if (isPlaceholderProfile(member)) return <Avatar size={size} placeholder alt={name} />;

  const color = getAvatarColorClass(name);
  return (
    <Avatar
      size={size}
      initials={getInitials(name)}
      alt={name}
      className={size === 'md' ? `${color} text-[9px]` : color}
    />
  );
}

export default memo(MemberAvatar);
